<template>
  <div class="popup">
    <div class="popup__test-wrap">
      <div class="popup__test-body">{{ getModalData.message }}</div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: "ModalTestMessage",
    computed: {
      ...mapGetters([
        'getModalData'
      ])
    },
    methods: {
      ...mapActions([
        'closeModal',
      ])
    }
  }
</script>

<style>

</style>